import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  removeBackgroundImageData: [],
  showCanvas: [],
  isImageProcessing: [],
  singleImageObj: {},
  shouldCallFunction: false,
};

const slice = createSlice({
  name: 'removeBackground',
  initialState: initialState,
  reducers: {
    setRemoveBackgroundImageData: (state, { payload }) => {
      // Check if an entry with the same id already exists

      const existingEntryIndex = state.removeBackgroundImageData.findIndex(
        (item) => item.id === payload.id,
      );

      // If the entry doesn't exist, add it to the array
      if (existingEntryIndex !== -1) {
        const updatedArray = [...state.removeBackgroundImageData];
        updatedArray[existingEntryIndex] = payload;
        return {
          ...state,
          removeBackgroundImageData: updatedArray,
        };
      } else {
        return {
          ...state,
          removeBackgroundImageData: [
            ...state.removeBackgroundImageData,
            payload,
          ],
        };
      }
    },

    setIsShowProcessedImage: (state, { payload }) => {
      // Implementation for this reducer remains unchanged
      const existingEntryIndex = state.showCanvas.findIndex(
        (item) => item === payload,
      );
      if (existingEntryIndex === -1) {
        return {
          ...state,
          showCanvas: [...state.showCanvas, payload],
        };
      } else {
        return {
          ...state,
          showCanvas: state.showCanvas.filter((item) => item !== payload),
        };
      }
    },
    setIsShowProcessedImageAfterRemoval: (state, { payload }) => {
      const existingEntryIndex = state.showCanvas.findIndex(
        (item) => item === payload,
      );
      if (existingEntryIndex === -1) {
        return {
          ...state,
          showCanvas: [...state.showCanvas, payload],
        };
      }
    },
    resetIsShowProcessedImage: (state) => {
      const filteredData = state.removeBackgroundImageData.filter((item) =>
        state.isImageProcessing.includes(item.id),
      );
      return {
        ...state,
        showCanvas: [],
        removeBackgroundImageData: filteredData,
      };
    },

    resetIsShowProcessedImageBasedOnId: (state, { payload }) => {
      const filteredData = state.removeBackgroundImageData.filter((item) =>
        state.isImageProcessing.includes(item.id),
      );
      const filteredShowCanvas = state.showCanvas.filter(
        (item) => item !== payload,
      );
      return {
        ...state,
        showCanvas: filteredShowCanvas,
        removeBackgroundImageData: filteredData,
      };
    },

    setIsImageProcessing: (state, { payload }) => {
      const existingEntryIndex = state.isImageProcessing.findIndex(
        (item) => item === payload,
      );

      if (existingEntryIndex === -1) {
        return {
          ...state,
          isImageProcessing: [...state.isImageProcessing, payload],
        };
      }
    },

    resetIsImageProcessing: (state) => {
      return {
        ...state,
        isImageProcessing: [],
      };
    },

    resetIsImageProcessingBasedOnId: (state, { payload }) => {
      const existingEntryIndex = state.isImageProcessing.findIndex(
        (item) => item === payload,
      );
      if (existingEntryIndex !== -1) {
        return {
          ...state,
          isImageProcessing: state.isImageProcessing.filter(
            (item) => item !== payload,
          ),
        };
      }
    },
    setSingleImageObj: (state, { payload }) => {
      return {
        ...state,
        singleImageObj: payload,
      };
    },
    setShouldCallFunction: (state, { payload }) => {
      return {
        ...state,
        shouldCallFunction: payload,
      };
    },

    resetEverything: () => {
      return initialState;
    },
  },
});

export const {
  setIsShowProcessedImage,
  setRemoveBackgroundImageData,
  resetIsShowProcessedImage,
  resetIsShowProcessedImageBasedOnId,
  setIsImageProcessing,
  resetIsImageProcessing,
  resetIsImageProcessingBasedOnId,
  setIsShowProcessedImageAfterRemoval,
  setSingleImageObj,
  setShouldCallFunction,
  resetEverything,
} = slice.actions;

export default slice.reducer;
